export default "__VITE_ASSET__BX58BPQu__"